import classes from './ProfileTitle.module.css';
import TitleLine from '../../Assets/TitleLine/TitleLine';
import FormButton from '../../Assets/FormButton/FormButton';
import TitleHeader from '../../Assets/TitleHeader/TitleHeader';
import { useRoutesContext } from '../../../contexts/RoutesContext';

interface Props {
    employeeId: number,
    employeeName: string,
    employeeFormStatus: string,
    employeeFormId: number | null,
    employeeUnitId: number
};

const ProfileTitle = ({ employeeId, employeeName, employeeFormStatus, employeeFormId, employeeUnitId }: Props) => {

    const { routes } = useRoutesContext();

    return (
        <>
            <div className={classes.profileTitleContainer}>
                <TitleHeader
                    headerText={employeeName}
                />
                <FormButton
                    redirectUrl={
                        employeeFormId ?
                            `/${routes.form}/${employeeUnitId}/${employeeId}/${employeeFormId}`
                            :
                            `/${routes.form}/${employeeUnitId}/${employeeId}`
                    }
                    formExists={employeeFormId ? true : false}
                />
            </div>
            <TitleLine />
        </>
    )
};

export default ProfileTitle;